module.exports = __webpack_public_path__ + "img/cd-image.6e9b98e8.jpg";